
<div class="cp-modal">
  <slot />
</div>
